import React, { useEffect, useState } from "react";
import bottom_flower from "../../assets/images/svg/bottom_flower.svg";
import button_yellow_left_layer from "../../assets/images/svg/button-yellow-left-layer.svg";
import button_yellow_right_layer from "../../assets/images/svg/button-yellow-right-layer.svg";
import top_flower from "../../assets/images/svg/top_flower.svg";
import temple_the_great_souls from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatSolusBgDecorate from "../../assets/images/the-great-souls/png/greatSolusBgDecorate.png";
import CommonHeading from "../common/heading/CommonHeading";
import { GreatSoulsList, ModalList } from "../../utils/TheGreatSoulsHelper";
import Modal from "../common/modal/Modal";
const TheGreatSouls = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }
    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls" id="great-souls">
        {/* <img
          className="position-absolute bottom_flower_mahamantra_two end-0 "
          src={bottom_flower}
          alt="no"
        /> */}
        <img
          src={temple_the_great_souls}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="#"
        />
        <img
          src={greatSolusBgDecorate}
          className="greateSolusBgDecorate position-absolute"
          alt="#"
        />
        {/* <img
          className="position-absolute top_flower_mahamantra top_flower_mahamantra_2 souls_top_flower start-0"
          src={top_flower}
          alt="no"
        />*/}

        <div className="container_modified container position-relative z-3 mt-sm-5 pt-5 pt-sm-3 pt-lg-4">
          <div className="row justify-content-center mt-3 mt-sm-0 mt-xl-2">
            <div className="col-lg-10 text-center px-4 mb-4 pb-lg-3">
              <CommonHeading
                heading="THE GREAT SOULS"
                className="common_heading_text_brown common_heading_text text-orange"
              />
              <h2 className="common_sub_heading text-center mb-3 mb-md-3">
                Who can give you <br />
                what you truly want?
              </h2>
              <p className="common_para mb-2 lh_25">
                In order to get, you have to receive. Who can give you what you
                truly want? Only someone who totally and lastingly and in the
                most integrated way made the journey on which you also, in your
                unique path, are walking. Thus, the need for a teacher - whether
                you are learning about auto mechanics or software engineering or
                spiritual science - is inescapably profound. Thank God, there are Great Souls who have surrendered themselves
                to their deepest purpose: Showing others the Path to Peace and
                helping them stride toward Fullness of Light, Love and Life.The spiritual path, in whose honor and energy Trimurti Ashram
                has been founded, is the fullest, fastest and most complete
                possible - wide enough for all who are interested, protected by
                the entirety of Divine Guidance, and empowered for true and
                lasting spiritual progress.
              </p>
            </div>
          </div>
          <div className="row justify-content-center mb-5 pb-4">
            {GreatSoulsList.map((obj, index) => {
              return (
                <div
                  className={`col-md-6 col-lg-4 ${obj.customClass}`}
                  key={index}
                >
                  <div
                    className="position-relative text-center cursor_pointer"
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-relative">
                      <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 mb-3">
                        <div className="position-relative z-3 w_fit_content mx-auto">
                          <img
                            className="position-absolute name_lable_image navbar_left_vector z_index_1 start-0"
                            src={button_yellow_left_layer}
                            alt="vector"
                          />
                          <img
                            className="position-absolute name_lable_image navbar_right_vector z_index_1 end-0"
                            src={button_yellow_right_layer}
                            alt="vector"
                          />
                          <button className="name_lable fs_sm_14">
                            {obj.title}
                          </button>
                        </div>
                      </div>
                      <img
                        src={obj.image}
                        className="w-100 max_sm_w common_card_hov transition_03 "
                        alt="soul"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSouls;
